// nothing has been finalized for Avatar currently by design team, hence keeping random color
export const DEFAULT_BACKGROUND_LETTER = 'brown';

export const DEFAULT_BACKGROUND_ICON = 'inherit';

export const DUMMY_IMAGE_URL =
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzHQv_th9wq3ivQ1CVk7UZRxhbPq64oQrg5Q&usqp=CAU';
